import React from 'react';

const DeleveryTerms = () => {
    return (
        <div className=" mt-20  ">
            <div className=" py-10 text-center text-gray-600 bg-gray-100 rounded-lg">
                <div className="max-w-6xl mx-auto">
                    <h1 className="text-4xl font-bold ">
                    Shipping and Delivery
                    </h1>
                </div>
            </div>

            <div className="max-w-6xl mx-auto bg-white p-10 rounded-lg mt-10">

                <h2 className="text-2xl font-semibold text-gray-800 mb-4">Shipping and Delivery</h2>
                <p className="text-lg text-gray-800 mb-8">
                Orders will be delivered within a maximum of 7 days. Delivery times may vary based on your location and other factors. We are not responsible for any delays in delivery caused by unforeseen circumstances.
                </p>

            </div>
        </div>
    );
};

export default DeleveryTerms;
